import React from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import { FormattedMessage } from 'react-intl'
import RawHtml from 'stories/components/RawHtml'

class Signature extends React.Component {
  render() {
    const { error, touched, label, required, description } = this.props

    const classNames = {
      'formz-has-error': error,
      'full-width': true,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div className="formz-input-title">
            {label} {required && '(*)'}
          </div>
          <RawHtml className="formz-field-description" content={description} />
          <div
            className="form-border-theme"
            style={{
              width: '100%',
              minHeight: 250,
              marginBottom: 16,
              borderWidth: '1px',
              borderStyle: 'solid',
              backgroundColor: 'white',
            }}
          ></div>
          <button
            className="formz-button"
            style={{
              width: 100,
              height: '32px',
              borderRadius: 4,
              cursor: 'pointer',
            }}
          >
            <FormattedMessage id="general.clear" />
          </button>
        </label>
      </FieldRowWrapper>
    )
  }
}
export default Signature
